import Component from "@tunnel-components/@pages/resetPassword/component";
import * as React from "react";
import { connect } from "react-redux";
import { NewPassWordActionCreator } from "@tunnel-store/index";
import * as Lodash from "lodash";
import * as Paths from "@tunnel-enums/index";
import { LoginContainerStates } from "@tunnel-models/index";

/**
 * @class Container : Composant à état
 * @description : composant “complexe” recevant des props et possédant
 * un état interne pour générer son rendu.
 * @extends { React.PureComponent }
 * @implements
 * @method
 * @name onChangeValue
 * @name onSubmitValues
 * @name componentWillUnmount
 * @name componentWillReceiveProps
 * @name render
 * @infos "https://reactjs.org"
 */
class Container extends React.PureComponent<
  any,
  LoginContainerStates<any, boolean>
> {
  //  faire cette action toute les 50 millisecondes
  public debounceChange = Lodash.debounce((event: any) => {
    {
      /** Empêcher la mutation du state */
    }
    this.setState((state: any): any => ({
      error: false,
      loading: false,
      warning: false,
      warningNoidentique: false,
    }));
    {
      /** Empêcher la mutation du state */
    }
    this.setState({ [event.target.name]: event.target.value });
  }, 50);
  /**
   * @constructor
   * @description :
   * Le Constructor est invoqué en premier.
   * Il reçoit en argument toutes les props initiales du composant
   * Le Constructor est aussi utilisé pour Binder les events Handler à l’instance.
   * @param { objet <any> } props
   */
  public constructor(props: any) {
    /**
     * @function
     * @description : Utilisé afin d'appeler ou d'accéder
     * à des fonctions définies sur l'objet parent.
     */
    super(props);
    /**
     * @namespace
     * @property { object }       state
     * @property { string }       state.confirmpassword
     * @property { boolean }      state.error
     * @property { string }       state.key
     * @property { boolean }      state.loading
     * @property { string }       state.newpassword
     * @property { boolean }      state.warning
     * @property { boolean }      state.success
     */
    this.state = {
      confirmpassword: "",

      error: false,
      key: props.match.params.reset,
      loading: false,
      newpassword: "",
      passwordTypeNewConfirm: true,
      passwordTypeNew: true,
      success: false,
      warning: false,
      warningNoidentique: false,
      submitSend: true,
    };
    /**
     * @description : Empêcher l'exécution des méthodes à chaque initialisation
     * des composants ; "seulement quand un event est exécuté"
     */
    this.onChangeValue = this.onChangeValue.bind(this);
    this.onSubmitValues = this.onSubmitValues.bind(this);
    this.onChangePasswordType = this.onChangePasswordType.bind(this);
    this.onChangePasswordTypeConfirm = this.onChangePasswordTypeConfirm.bind(
      this
    );
  }
  /**
   * manipulation des valeurs des inputs
   * @public
   * @method onChangePasswordType
   * @param { React.ChangeEvent<HTMLInputElement>  }  event
   * @infos "https://reactjs.org"
   */
  public onChangePasswordType = (
    event: React.ChangeEvent<HTMLInputElement>
  ): void => {
    {
      /** Empêcher la mutation du state */
    }
    this.setState((state: any): any => ({
      passwordTypeNew: !this.state.passwordTypeNew,
    }));
  };
  /**
   * manipulation des valeurs des inputs
   * @public
   * @method onChangePasswordTypeConfirm
   * @param { React.ChangeEvent<HTMLInputElement>  }  event
   * @infos "https://reactjs.org"
   */
  public onChangePasswordTypeConfirm = (
    event: React.ChangeEvent<HTMLInputElement>
  ): void => {
    {
      /** Empêcher la mutation du state */
    }
    this.setState((state: any): any => ({
      passwordTypeNewConfirm: !this.state.passwordTypeNewConfirm,
    }));
  };
  /**
   * manipulation des valeurs des inputs
   * @public
   * @method
   * @name onChangeValue
   * @param { React.ChangeEvent<HTMLInputElement>  }  event
   * @infos "https://reactjs.org"
   */
  public onChangeValue = (event: React.ChangeEvent<HTMLInputElement>): void => {
    {
      /** Empêcher le rechargement de la page */
    }
    // Faire persister mon événement
    event.persist();

    /**
     * Afin d'améliorer la performance de l'interface on utilise des actions
     * espacé dans le temps
     */
    this.debounceChange(event);
  };

  /**
   * Redirection après des inputs
   * @public
   * @method onSubmitValues
   * @param { React.ChangeEvent<HTMLInputElement>  }  event
   * @infos "https://reactjs.org"
   */
  public onSubmitValues = (
    event: React.ChangeEvent<HTMLInputElement>
  ): void => {
    {
      /** Empêcher le rechargement de la page */
    }
    event.preventDefault();
    {
      /** Empêcher la mutation du state */
    }
    this.setState((state: any): any => ({
      error: false,
      warning: false,
      warningNoidentique: false,
      submitSend: false,
    }));
    {
      /**  test du type ou existence du paramètre */
    }
    if (
      !Lodash.isEmpty(this.state.confirmpassword) &&
      !Lodash.isEmpty(this.state.newpassword)
    ) {
      this.setState((state: any): any => ({ error: false }));
      {
        /**  test du type ou existence du paramètre */
      }
      if (Lodash.isEqual(this.state.confirmpassword, this.state.newpassword)) {
        if (this.state.confirmpassword.length >= 6) {
          if (
            !Lodash.isUndefined(this.state.key) &&
            !Lodash.isEmpty(this.state.key)
          ) {
            this.props.NewPassWordActionCreator(this.state); // action creator
          }
        } else {
          this.setState((state: any): any => ({
            warningNoidentique: true,
            submitSend: true,
          }));
        }
      } else {
        {
          /** Empêcher la mutation du state */
        }
        this.setState((state: any): any => ({
          warningNoidentique: true,
          submitSend: true,
        }));
      }
    } else if (
      Lodash.isEmpty(this.state.confirmpassword) ||
      Lodash.isEmpty(this.state.newpassword)
    ) {
      this.setState((state: any): any => ({ warning: true, submitSend: true }));
    }
  };
  /**
   * Cycle de vie d'un composant react
   * @method
   * @name componentWillUnmount
   * @description : il est appelée.
   * Avant que le composant soit supprimé du DOM.
   * Cette méthode peut être utile lorsque vous devez effectuer
   * des opérations de nettoyage.
   * @param { void }
   * @infos "https://reactjs.org"
   */
  public componentWillUnmount() {
    {
      /** Empêcher la mutation du state */
    }
    this.setState((state: any): any => ({
      error: false,
      loading: false,
      passwordTypeNewConfirm: true,
      passwordTypeNew: true,
      warning: false,
      warningNoidentique: false,
      submitSend: true,
    }));

    // Stopper l'action une fois le component détruit
    this.debounceChange.cancel();
  }
  /**
   * Cycle de vie d'un composant react
   * @method
   * @name componentWillReceiveProps
   * @description : La méthode  est appelée uniquement lorsque les props
   * ont changé et lorsqu'il ne s'agit pas d'un rendu initial
   * Le composant passe par une autre série d’étapes lorsque son parent refait son rendu
   * C’est l’endroit idéal pour vérifier si vos props vont changer par exemple
   * @param { any } nextProps
   * @infos "https://reactjs.org"
   */
  public componentWillReceiveProps(nextProps: any) {
    if (nextProps.password.data !== this.props.password.data) {
      {
        /** Empêcher la mutation du state */
      }
      if (!Lodash.isUndefined(nextProps.password.data)) {
        this.setState((state: any): any => ({
          error: false,
          success: true,
          warning: false,
          warningNoidentique: false,
          submitSend: true,
        }));

        setTimeout(() => {
          const _URL = Paths.PathsNamesEnums.TUNNELWATCH;
          this.props.history.push(_URL);
        }, 5000);
      }

      {
        /** comparaison */
      }
    } else if (nextProps.password.error !== this.props.password.error) {
      {
        /** Empêcher la mutation du state */
      }
      this.setState((state: any): any => ({
        error: true,
        loading: false,
        passwordTypeNewConfirm: true,
        passwordTypeNew: true,
        success: false,
        warning: false,
        warningNoidentique: false,
        submitSend: true,
      }));
    }
  }

  /**
   * Cycle de vie d'un composant react
   * @method
   * @name render
   * @description : il est appelée. Pour le rendu ,
   * Ici le DOM virtuel fusionne avec le DOM réel
   * @param {  }
   * @infos "https://reactjs.org"
   */
  public render() {
    return (
      <Component
        {...this.props}
        {...this.state}
        onChangeValue={this.onChangeValue}
        onSubmitValues={this.onSubmitValues}
        onChangePasswordType={this.onChangePasswordType}
        onChangePasswordTypeConfirm={this.onChangePasswordTypeConfirm}
      />
    );
  }
}
/**
 * @function
 * @name mapStateToProps
 * @description : mapStateToProps prend
 * un composant en entrée et retourne le même composant avec de props
 * @param { any } state
 * @infos "https://react-redux.js.org/using-react-redux/connect-mapstate"
 */
export function mapStateToProps(state: any) {
  {
    /** nouveaux props */
  }
  return {
    error: state.NewPassWord.error,
    password: state.NewPassWord,
  };
}
{
  /** exporter le HOC : connect */
}
export default connect(mapStateToProps, { NewPassWordActionCreator })(
  Container
);



// WEBPACK FOOTER //
// ./src/apps/tunnel/components/@pages/resetPassword/container.tsx